import React from 'react';


export class StarRating extends React.Component {

  onClick(starNumber, e){
    if (this.props.onClick){
      this.props.onClick(starNumber, e);
    }
  }

  onMouseEnter(starNumber, e){
    if (this.props.onMouseEnter){
      this.props.onMouseEnter(starNumber, e);
    }
  }

  onMouseLeave(e){
    if (this.props.onMouseLeave){
      this.props.onMouseLeave(e);
    }
  }

  render(){
    var imageSrc, rating = this.props.rating;

    var stars = [1, 2, 3, 4, 5].map(function(starNumber){
      imageSrc = rating >= starNumber ? "https://images.custommade.com/02-17/211862/5acdf8d9abf68ee_star.svg" : "https://images.custommade.com/02-17/211862/20ebd293dd70b96_star_gray.svg";
      return <img key={starNumber} src={imageSrc} onMouseEnter={this.onMouseEnter.bind(this, starNumber)} onClick={this.onClick.bind(this, starNumber)}/>
    }.bind(this))
    return (
      <div className={this.props.className ? "rate_container " + this.props.className : "rate_container"} onMouseLeave={this.onMouseLeave.bind(this)}>
        {stars}
      </div>
    )
  }
}

export class PartialStarRating extends React.Component {

  render(){
    return (
      <div className="stars_display">
        <div className="stars_fill" style={{"width": (this.props.rating * 100/5.0).toString() + "%"}}>
          <svg className="star">
            <use x="0" y="0" xlinkHref="#star" />
            <use x="14" y="0" xlinkHref="#star" />
            <use x="28" y="0" xlinkHref="#star" />
            <use x="42" y="0" xlinkHref="#star" />
            <use x="56" y="0" xlinkHref="#star" />
          </svg>
        </div>
        <div className="stars_background">
          <svg className="star" fill="#e3e3e3">
            <use x="0" y="0" xlinkHref="#star_bg" />
            <use x="14" y="0" xlinkHref="#star_bg" />
            <use x="28" y="0" xlinkHref="#star_bg" />
            <use x="42" y="0" xlinkHref="#star_bg" />
            <use x="56" y="0" xlinkHref="#star_bg" />
          </svg>
        </div>
      </div>
    );
  }
}


export class StarRatingWidget extends React.Component {

  constructor(props){
    super(props);
    let initialRating = this.props.initialRating;
    this.state = {
      'rating': initialRating || 0,
      'shownRating': initialRating || 0
    };
  }

  setShownRating(starNumber, _e){
    this.setState({
      shownRating: starNumber
    });
  }

  setRating(starNumber, _e){
    this.setState({
      rating: starNumber
    });
    this.props.updateRating(this.props.name, starNumber);
  }

  mouseLeave(_e){
    this.setState({
      shownRating: this.state.rating
    });
  }

  render(){
    var _imageSrc, rating = this.state.shownRating;
    return <StarRating onMouseEnter={this.setShownRating.bind(this)} onMouseLeave={this.mouseLeave.bind(this)} onClick={this.setRating.bind(this)} rating={rating} />
  }
}
